import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label } from "reactstrap";
import DefaultButton from "../../../components/Buttons/Default";
import { Link } from "react-router-dom";
import { post } from "../../../utils/helpers/api";
import { toast } from "react-toastify";

function EmailLinkPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const sendResetLink = async () => {
    setLoading(true);
    const data = await post('/password/email', { email });
    if(data.success) {
      toast.success(t('auth.resetLinkSent'));
      setEmail('');
    } else {
      toast.error(data.message || t('auth.resetLinkFailed'));
    }
    setLoading(false);
  };

  return(
    <main className="auth-page">
      <div className="auth-container">
         <div className="login-card">
            <div className="login-header">
              <h2 className="login-title">{t('auth.passwordResetTitle')}</h2>
              <p className="login-subtitle">
                {t('auth.passwordResetSubtitle')}
              </p>
            </div>

            <FormGroup>
              <Label>{t('auth.emailAddress')}</Label>
              <Input
                name="email"
                type="email"
                placeholder={t('auth.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </FormGroup>

            <DefaultButton
              block
              onClick={sendResetLink}
              loading={loading}
              disabled={!email || loading}
            >
              {t('auth.sendResetLink')}
            </DefaultButton>

            <div className="text-center small mt-2">
              <Link to="/">{t('auth.backToLogin')}</Link>
            </div>
         </div>
      </div>
    </main>
  );
}

export default EmailLinkPage;